import { useRef } from "react";
import { Button } from "antd";
const getValueByProp = function (data, prop, propVal, r = { status: false, result: null }) {
    if (!data)
        return r;
    if (data && data.hasOwnProperty(prop) && data[prop] == propVal) {
        r.status = true;
        r.result = data;
    }
    for (let i in data) {
        if (data[i] && typeof data[i] == "object") {
            const tmp = getValueByProp(data[i], prop, propVal, r);
            if (tmp.status)
                return tmp;
        }
    }
    return r;
};
const GrtBtn = function (props) {
    let object = Object.assign({}, props);
    object.beforeClick && delete object.beforeClick;
    object.click && delete object.click;
    object.afterClick && delete object.afterClick;
    const editorRef = useRef(null);
    const onClickFunc = async (e) => {
        if (props.beforeClick) {
            const r = getValueByProp(props.__events.eventDataList, "name", "beforeClick");
            let params = null;
            if (r.status) {
                const result = r.result;
                params = new Function("return " + result['paramStr'])();
            }
            const result = await props.beforeClick(e, params);
            if (!result)
                return Promise.resolve(false);
        }
        if (props.click) {
            const r = getValueByProp(props.__events.eventDataList, "name", "click");
            let params = null;
            if (r.status) {
                const result = r.result;
                params = new Function("return " + result['paramStr'])();
            }
            await props.click(e, params);
        }
        if (props.afterClick) {
            const r = getValueByProp(props.__events.eventDataList, "name", "afterClick");
            let params = null;
            if (r.status) {
                const result = r.result;
                params = new Function("return " + result['paramStr'])();
            }
            await props.afterClick(e, params);
        }
    };
    return (<>
            <Button {...object} onClick={onClickFunc} ref={editorRef}>{props.content || "按钮"}</Button>
        </>);
};
export default GrtBtn;
